var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3329 9.14102V10.8577C18.3329 11.316 17.9662 11.691 17.4995 11.7077H15.8662C14.9662 11.7077 14.1412 11.0494 14.0662 10.1493C14.0162 9.62435 14.2162 9.13268 14.5662 8.79102C14.8745 8.47435 15.2995 8.29102 15.7662 8.29102H17.4995C17.9662 8.30768 18.3329 8.68268 18.3329 9.14102Z",
    fill: "#007FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0577 12.9577H15.866C14.2827 12.9577 12.9493 11.766 12.816 10.2493C12.741 9.38268 13.0577 8.51602 13.691 7.89935C14.2243 7.34935 14.966 7.04102 15.766 7.04102H17.0577C17.2993 7.04102 17.4993 6.84102 17.4743 6.59935C17.291 4.57435 15.9493 3.19102 13.9577 2.95768C13.7577 2.92435 13.5493 2.91602 13.3327 2.91602H5.83268C5.59935 2.91602 5.37435 2.93268 5.15768 2.96602C3.03268 3.23268 1.66602 4.81602 1.66602 7.08268V12.916C1.66602 15.216 3.53268 17.0827 5.83268 17.0827H13.3327C15.666 17.0827 17.2743 15.6243 17.4743 13.3993C17.4993 13.1577 17.2993 12.9577 17.0577 12.9577ZM10.8327 8.12435H5.83268C5.49102 8.12435 5.20768 7.84102 5.20768 7.49935C5.20768 7.15768 5.49102 6.87435 5.83268 6.87435H10.8327C11.1743 6.87435 11.4577 7.15768 11.4577 7.49935C11.4577 7.84102 11.1743 8.12435 10.8327 8.12435Z",
    fill: "#007FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpense);
export default __webpack_public_path__ + "static/media/expense.92cc60010a8d1db2116dde2344d169b7.svg";
export { ForwardRef as ReactComponent };